module.exports = __webpack_public_path__ + "img/1945_Bombentreffer-Styria-1945.b08e2ceb.jpg";